class SwiperJS {
    constructor(parent, data) {
        this.parent = parent
        this.init()
    }
    init() {
        document.querySelectorAll('[data-swiper]').forEach(el => {
            new SwiperJSItem(el)
        })
    }
}

class SwiperJSItem {
    constructor(el) {
        this.el = el
        this.init()
    }
    init() {
        this.swiper = new Swiper(this.el, {
            slidesPerView: 'auto',
        });
        const resizeObserver = new ResizeObserver(() => {
            this.swiper.update();
        });
        this.el.querySelectorAll('.swiper-slide').forEach(el => {
            resizeObserver.observe(el);
        });
    }
}

export default SwiperJS